import SwitchConnectivity from './SwitchConnectivity';
import TabAnchorLinks from './components/TabAnchorLinks';

export {TabAnchorLinks};
export default SwitchConnectivity;
